import React, { useState, useRef } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import ThemeSwitcher from './ThemeSwitcher';
import { useTheme } from "../contexts/ThemeContext";
import ChangePasswordDialog from './ChangePasswordDialog';

const Header = ({ title = 'WGSol', showThemeSwitcher = true, onToggleSidebar }) => {
    const { theme } = useTheme();
    const [displayChangePasswordDialog, setDisplayChangePasswordDialog] = useState(false);
    const menuRef = useRef(null);

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/entrar";
    };

    const menuItems = [
        {
            label: 'Alterar Senha',
            icon: 'pi pi-fw pi-lock',
            command: () => setDisplayChangePasswordDialog(true),
        },
        {
            separator: true,
        },
        {
            label: 'Sair',
            icon: 'pi pi-fw pi-sign-out',
            command: handleLogout,
        },
    ];

    const logoSrc = theme === 'dark' 
        ? require("../images/logo-dark.png") 
        : require("../images/logo.png");

    const startContent = (
        <div className="header-title">
            {onToggleSidebar && (
                <Button
                    icon="pi pi-bars"
                    onClick={onToggleSidebar}
                    className="header-menu-button"
                    text
                    rounded
                    aria-label="Toggle menu"
                />
            )}
            <img src={logoSrc} alt="WGSol Logo" />
        </div>
    );

    const endContent = (
        <div className="header-actions" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {showThemeSwitcher && <ThemeSwitcher />}
            <Menu model={menuItems} popup ref={menuRef} />
            <Button
                icon="pi pi-fw pi-user"
                onClick={(e) => menuRef.current.toggle(e)}
                className="p-button-rounded p-button-text"
                
            />
        </div>
    );

    return (
        <>
            <Toolbar
                className="header-toolbar"
                start={startContent}
                end={endContent}
            />
            <ChangePasswordDialog
                visible={displayChangePasswordDialog}
                onHide={() => setDisplayChangePasswordDialog(false)}
                onSuccess={() => setDisplayChangePasswordDialog(false)}
            />
        </>
    );
};

export default Header;
